import { render, staticRenderFns } from "./ModalShowNullifiedPostulatedProject.vue?vue&type=template&id=4f172622&scoped=true"
import script from "./ModalShowNullifiedPostulatedProject.vue?vue&type=script&lang=js"
export * from "./ModalShowNullifiedPostulatedProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f172622",
  null
  
)

export default component.exports